const SERVICE = "tsq-admin";

const formatTime = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const formatMeta = (meta) => {
  if (meta === undefined || meta === null) return "";
  try {
    return ` ${JSON.stringify(meta)}`;
  } catch {
    return " [unserializable meta]";
  }
};

const emit = (consoleFn, level, msg, meta) => {
  consoleFn(`[${formatTime()}] [${level}] [${SERVICE}] ${msg}${formatMeta(meta)}`);
};

const logger = {
  info: (msg, meta) => emit(console.info, "info", msg, meta),
  warn: (msg, meta) => emit(console.warn, "warn", msg, meta),
  error: (msg, meta) => emit(console.error, "error", msg, meta),
  debug: (msg, meta) => emit(console.debug, "debug", msg, meta),
};

export default logger;
